import { IAuthActions } from "../../action-types/auth/IAuthActions";
import { IAuthReducer } from "../../reducer-model/auth/IAuthReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: IAuthReducer = {
    status: eReducerStatusBase.is_not_initialization,
    user: null,
    access_token: null,
    error_message: "",
    must_change_password: false,
    password_weak_reason: undefined,
};

export const authReducer = (state: IAuthReducer = initialState, action: IAuthActions): IAuthReducer => {
    switch (action.type) {
        case "AUTH_LOGIN_START":
        case "AUTH_LOGIN_VNPT_START":
        case "AUTH_LOGIN_NAMVIET_START":
            return { ...state, status: eReducerStatusBase.is_loading, error_message: "" };
        case "AUTH_LOGIN_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                user: action.payload.user,
                access_token: action.payload.access_token,
                error_message: "",
                must_change_password: !!action.payload.must_change_password,
                password_weak_reason: action.payload.password_weak_reason,
            };
        case "AUTH_RESTORE_SESSION":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                user: action.payload.user,
                access_token: action.payload.access_token,
                must_change_password: !!action.payload.must_change_password,
                password_weak_reason: action.payload.password_weak_reason,
            };
        case "AUTH_PASSWORD_CHANGED":
            // Đổi mật khẩu thành công → thay token mới (đã bỏ pwd_must_change) + gỡ cờ buộc đổi.
            return {
                ...state,
                access_token: action.payload.access_token,
                must_change_password: false,
                password_weak_reason: undefined,
            };
        case "AUTH_LOGIN_ERROR":
            return { ...state, status: eReducerStatusBase.is_error, error_message: action.payload };
        case "AUTH_LOGOUT":
            return { ...initialState };
        default:
            return state;
    }
};
